<template>
	<div class="details">
		<div class="conten_body">  
			<h3 class="consu_title"><a href="/">首页 </a>> <router-link  to="/articleList">热点资讯</router-link></h3>	
			<div class="conten_left">
				<h2 class="con_lef_tit">周晓峰：什么是信息安全风险评估?</h2>
				<p class="article_time">
				2019-10-18
				<span class="item_art">杭州网</span>
				<span class="vp"><i class="el-icon-view"></i>255</span>
			    </p>
				<section class="articleWords ">
						<p>依据国家信息安全标准《信息安全技术 信息安全风险评估规范》(GB/T 
20984-2007)的定义，信息安全风险评估是“对信息系统及由其处理、传输和存储的信息的机密性、完整性和可用性等安全属性进行评价的过程。”</p><p>　　<a href="http://www.wfnetworks.cn/service/showproduct.php?id=73" target="_blank" title="">信息安全风险评估</a>的主要任务是评估资产面临的威胁以及威胁利用脆弱性导致安全事件的可能性，并结合资产价值来判断安全事件一旦发生对组织造成的影响，进而为应如何进一步强化安全控制措施提供依据及建议。</p><p>　　这里我们提到了4个概念：资产、威胁、脆弱性和安全控制措施，下面我们就简单介绍一下这些概念的含义——</p><p>　　1)资产：信息安全风险评估中所说的资产是任何对组织(如公司、政府机构等各类组织机构)有价值的信息资源，可以包括电子文档、纸质文档材料、软件、硬件、人员、服务性资产等。里面还有“人员”?对，人员也是信息安全风险评估的对象。</p><p>　　2)威胁：信息安全风险评估中的威胁概念指可能对资产或组织造成损害的潜在原因及活动，包括黑客入侵和攻击、病毒木马等各类恶意程序、软硬件故障、人为误操作、自然灾害(如地震、火灾、爆炸等)、盗窃、网络监听、供电故障、未授权访问等，如下图所示。</p><p style="text-align: center;"><img src="http://www.wfnetworks.cn/upload/201910/da6a68c4-c594-4418-a5fa-9a767df5c28d.png" title="信息资产可能受到哪些威胁" alt="信息资产可能受到哪些威胁" width="734" height="419" border="0" vspace="0" style="width: 734px; height: 419px;"></p><p>　　3)脆弱性：可能被威胁利用对资产造成损害的薄弱环节。可以包括系统漏洞、软件Bug、专业人员缺乏、不良操作习惯、不合理的安全配置、不安全的物理环境、缺少审计、缺乏安全意识、软件后门等。</p><p>　　4)安全控制措施：是指组织所采取的降低安全风险的惯例，程序或机制。包括现有的安全控制措施、计划采取的安全控制措施。</p><p>　　在解释了信息安全风险评估所涉及的基本概念，就要讲讲如何信息安全风险评估是如何开展的。下面这张图表述了风险评估的基本流程。</p><p style="text-align: center;"><img src="http://www.wfnetworks.cn/upload/201910/bcb7dc92-84ef-4a4f-bf11-8c37aa80b129.png" title="图片关键词" alt="图片关键词"></p><p>　　其中最关键的4个过程就是资产识别、威胁识别、脆弱性识别和风险分析：</p><p>　　1)资产识别：首先是依据业务流程列出信息资产清单，包括：数据与文档、书面文件、软件、硬件、人员、服务等;然后对资产重要性进行量化，量化时应考虑的角度包括：资产损失可能对业务活动造成的影响、将信息资产恢复到正常状态所付出的代价、在公众形象和名誉上的损失、资产采购价值、对保密性/完整性/可用性的影响等多个方面。具体量化的的数值可以是1~5，也可以是1~100等，具体依赖于后面要讲到的风险计算方法。</p><p>　　2)威胁识别：是指对组织需要保护的每一项信息资产面临的威胁进行分析，应具体考虑每一项特定资产所处的环境条件以及以前遭受威胁损害的情况，应该指出的是，一项资产可能会有多个威胁。</p><p>　　3)脆弱性识别：是指全面评估信息资产由于由于缺乏充分的安全控制，自身存在的可能被威胁所利用的薄弱点。脆弱性识别将针对每一项信息资产，找出每一种威胁所能利用的薄弱点(脆弱性)、分析每一个脆弱性被特定威胁所利用的可能性、并分析每一个脆弱性一旦被特定威胁利用，对该资产造成的损失严重程度。</p><p>　　4)风险计算：即采用一种选定的计算方法对信息资产的风险进行量化计算。风险值的量化计算方法可以由评估者自主选定，国家标准中并没有规定必须采用哪种方法，常见的风险计算方法包括矩阵法和相乘法，简单的讲矩阵法就是根据资产的多个维度的属性在一个2维或多维矩阵中选择对应的风险值，而相乘法就是基于一个特定的函数，以资产的不同属性为变量计算风险值，“相乘”是函数关系的一般化表述，最简单的函数即多个变量的直接代数相乘。</p><p>　　最后，我们依据风险分析的结果得到各个资产的风险值，根据风险值的高低和种类以及提出合理的安全控制措施，具体包括接受现有风险、基于各种方法转移风险(如商业保险等)、采取措施降低或消除风险(如安全漏洞加固等)。</p><p>　　但应该指出的是：风险控制措施的选择是一种费用与风险的平衡，即风险要降低的越低，需要投入越高的费用(或资源)，信息安全风险不可能完全消除，我们要做的是投入可接受的资源将风险降低到合理的程度。</p><p>　　周晓峰(杭州市基础信息安全测评认证中心常务副主任、高级工程师)</p><p>　　来源：杭州网 作者：周晓峰 编辑：周夏</p><p><br></p>					</section>
          <div class="bottomLine"></div>
          <div class="articleNav">
           <p class="nextArticle">上一篇：<router-link to="consultDetail2">等级保护和网络安全法的关系？</router-link></p>
          <p class="nextArticle">下一篇：<router-link to="consultDetail">工信部：加强网络安全风险隐患排查，做好行业关键信息基础设施安全防护</router-link></p>
        </div>

			</div>
			<!-- right -->
			<Hotgoods  :contant="fetching"/>
			
		</div>
	</div>
</template>

<script type="text/javascript">
import Hotgoods from "@/components/hotgoods.vue"
// import Selectshop from "@/components/Selectshop.vue"

export default{
components:{
      Hotgoods//,
      // Selectshop
	},
data(){
	return{
		fetching:false,
	
	}
},
mounted(){

},
methods:{
	
}


};
</script>

<style type="text/css" lang="less" scoped>
.details{
	width:1200px;
	margin:0 auto;
//**/
.conten_body{
	margin-top:10px;
	overflow: hidden;
}
.conten_left{
	width:880px;
	float:left;
	background:#fff;
	box-sizing: border-box;
	padding:20px;
}
.consu_title{
	line-height: 32px;
    font-size: 14px;
    padding-left: 20px;
    color: #474747;
}
.con_lef_tit{
	text-align: left;
    font-size: 25px;
    font-weight: 400;
    color: #222222;
    padding:20px 0;
}
.article_time{
	margin-top: 10px;
    font-size: 13px;
    font-weight: 400;
    color: #999999;
}
.articleWords {
	margin-top: 10px;
	line-height: 26px;
    margin-bottom: 15px;
    font-size: 15px;
    color: #666666;
}
.articleWords p{
	font-size:15px;
	text-indent: 2em;
}
.articleWords strong{
	font-weight: bold;
}
.bottomLine{
	width: 100%;
    height: 1px;
    background: #E9E9E9;
    margin-bottom: 20px;
}
.articleNav{
	overflow:hidden;
}
.nextArticle{
    float:left;
	margin-top: 15px;
    font-size: 12px;
    color: #666666;
}
.nextArticle:nth-of-type(2){
	float:right;
}
.item_art{
	padding:0 5px;
}
.vp i{
	padding-right:3px;
}


}


</style>







